var styles = {"article":"ButtonBoxCombined-module_article__4TmLX","cell":"ButtonBoxCombined-module_cell__oVncJ","primary":"ButtonBoxCombined-module_primary__qAPwJ","tertiary":"ButtonBoxCombined-module_tertiary__oM2M9","secondary":"ButtonBoxCombined-module_secondary__ss9ZX","basic":"ButtonBoxCombined-module_basic__kw7rF"};

export { styles as default };
